export const INICIO_DESIGN = {
    page: {
        container: "h-full bg-[#f5f5f5] dark:bg-[#1A1D21] flex flex-col overflow-hidden",
        content: "flex-1",
        innerPadding: "max-w-[1280px] mx-auto w-full px-6 md:px-10 py-8 space-y-8",
    },
    greeting: {
        wrapper: "",
        title: "text-[26px] font-bold text-gray-900 dark:text-[#D1D2D3] tracking-tight leading-tight",
        subtitle: "text-sm text-gray-500 dark:text-[#ABABAD] mt-1",
    },
    shortcuts: {
        grid: "grid grid-cols-1 sm:grid-cols-3 gap-4",
        card: "group bg-white dark:bg-[#222529] rounded-xl border border-gray-200 dark:border-[#383838] p-5 flex flex-col gap-3 hover:shadow-lg hover:border-[#7C3AED]/30 transition-all duration-300 cursor-pointer min-h-[120px]",
        headerRow: "flex items-center justify-between",
        title: "text-sm font-bold text-gray-900 dark:text-[#D1D2D3]",
        iconBox: "w-10 h-10 rounded-xl flex items-center justify-center bg-[#7C3AED] shadow-sm shadow-violet-200 dark:shadow-none group-hover:scale-110 transition-transform",
        icon: "text-white",
        description: "text-xs text-gray-500 dark:text-[#ABABAD] leading-relaxed",
    },
    metricas: {
        grid: "grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3",
        card: "group bg-white dark:bg-[#222529] rounded-xl border border-gray-200 dark:border-[#383838] px-4 py-3.5 flex items-center gap-3 hover:shadow-md hover:border-gray-300 dark:hover:border-[#565856] transition-all duration-300",
        cardIconBox: "w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0",
        cardInfo: "flex flex-col min-w-0",
        cardValue: "text-xl font-bold text-gray-900 dark:text-[#D1D2D3] leading-tight tabular-nums",
        cardLabel: "text-[11px] text-gray-500 dark:text-[#ABABAD] mt-0.5 truncate font-medium",
        colors: {
            blue: { bg: "bg-blue-50 dark:bg-blue-500/10", text: "text-blue-600 dark:text-blue-400" },
            violet: { bg: "bg-violet-50 dark:bg-violet-500/10", text: "text-violet-600 dark:text-violet-400" },
            red: { bg: "bg-red-50 dark:bg-red-500/10", text: "text-red-600 dark:text-red-400" },
            green: { bg: "bg-green-50 dark:bg-green-500/10", text: "text-green-600 dark:text-green-400" },
            amber: { bg: "bg-amber-50 dark:bg-amber-500/10", text: "text-amber-600 dark:text-amber-400" },
            indigo: { bg: "bg-indigo-50 dark:bg-indigo-500/10", text: "text-indigo-600 dark:text-indigo-400" },
        },
    },
    twoColumns: {
        grid: "grid grid-cols-1 lg:grid-cols-2 gap-5 items-stretch",
    },
    tarefas: {
        card: "bg-white dark:bg-[#222529] rounded-xl border border-gray-200 dark:border-[#383838] overflow-hidden h-full flex flex-col",
        header: "flex items-center justify-between px-5 pt-4 pb-3",
        headerLeft: "flex items-center gap-2.5",
        headerIcon: "w-8 h-8 rounded-lg flex items-center justify-center bg-violet-50 dark:bg-[#7C3AED]/10",
        headerTitle: "text-sm font-bold text-gray-900 dark:text-[#D1D2D3]",
        headerLink: "text-xs font-semibold text-[#7C3AED] hover:text-[#6D28D9] cursor-pointer flex items-center gap-1 transition-colors",
        statsRow: "grid grid-cols-4 gap-2 px-5 pb-3",
        statPill: "flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg",
        statValue: "text-sm font-bold leading-none tabular-nums",
        statLabel: "text-[10px] text-gray-500 dark:text-[#ABABAD] leading-none font-medium",
        statDivider: "border-b border-gray-100 dark:border-[#383838]",
        list: "divide-y divide-gray-100 dark:divide-[#383838] flex-1",
        item: "flex items-center gap-3 px-5 py-3 hover:bg-violet-50/30 dark:hover:bg-[#383838]/30 transition-colors cursor-pointer group",
        itemContent: "flex-1 min-w-0",
        itemTitle: "text-[13px] font-medium text-gray-900 dark:text-[#D1D2D3] truncate group-hover:text-[#7C3AED] transition-colors",
        itemMeta: "flex items-center gap-2 mt-0.5",
        itemDate: "text-[11px] text-gray-400 dark:text-[#ABABAD]",
        itemDateOverdue: "text-[11px] text-red-500 dark:text-red-400 font-medium flex items-center gap-0.5",
        badge: "text-[10px] font-semibold px-2 py-0.5 rounded-full",
        priorityDot: "w-2 h-2 rounded-full flex-shrink-0",
        chevron: "text-gray-300 dark:text-[#565856] group-hover:text-[#7C3AED] transition-colors",
        statusColors: {
            'A Fazer': "bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-400",
            'Em Progresso': "bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-400",
            'Concluído': "bg-green-50 text-green-700 dark:bg-green-500/10 dark:text-green-400",
        },
        priorityColors: {
            urgent: "bg-red-500",
            high: "bg-orange-500",
            medium: "bg-amber-400",
            low: "bg-gray-300 dark:bg-gray-600",
        },
        statBg: {
            amber: "bg-amber-50/80 dark:bg-amber-500/5",
            blue: "bg-blue-50/80 dark:bg-blue-500/5",
            green: "bg-green-50/80 dark:bg-green-500/5",
            red: "bg-red-50/80 dark:bg-red-500/5",
        },
        statText: {
            amber: "text-amber-700 dark:text-amber-400",
            blue: "text-blue-700 dark:text-blue-400",
            green: "text-green-700 dark:text-green-400",
            red: "text-red-600 dark:text-red-400",
        },
        empty: "flex flex-col items-center justify-center py-10 px-5 flex-1",
        emptyIcon: "w-11 h-11 rounded-2xl flex items-center justify-center bg-gray-100 dark:bg-[#383838] mb-2.5",
        emptyText: "text-sm font-medium text-gray-500 dark:text-[#ABABAD]",
        emptySubtext: "text-xs text-gray-400 dark:text-[#565856] mt-0.5",
        skeleton: "animate-pulse flex items-center gap-3 px-5 py-3",
        skeletonBar: "h-3 bg-gray-100 dark:bg-[#383838] rounded-full",
    },
    chamados: {
        card: "bg-white dark:bg-[#222529] rounded-xl border border-gray-200 dark:border-[#383838] overflow-hidden h-full flex flex-col",
        header: "flex items-center justify-between px-5 pt-4 pb-3",
        headerLeft: "flex items-center gap-2.5",
        headerIcon: "w-8 h-8 rounded-lg flex items-center justify-center bg-blue-50 dark:bg-blue-500/10",
        headerTitle: "text-sm font-bold text-gray-900 dark:text-[#D1D2D3]",
        headerLink: "text-xs font-semibold text-[#7C3AED] hover:text-[#6D28D9] cursor-pointer flex items-center gap-1 transition-colors",
        statsRow: "grid grid-cols-4 gap-2 px-5 pb-3",
        statPill: "flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg",
        statValue: "text-sm font-bold leading-none tabular-nums",
        statLabel: "text-[10px] text-gray-500 dark:text-[#ABABAD] leading-none font-medium",
        statDivider: "border-b border-gray-100 dark:border-[#383838]",
        list: "divide-y divide-gray-100 dark:divide-[#383838] flex-1",
        item: "flex items-center gap-3 px-5 py-3 hover:bg-blue-50/30 dark:hover:bg-[#383838]/30 transition-colors cursor-pointer group",
        itemContent: "flex-1 min-w-0",
        itemTitle: "text-[13px] font-medium text-gray-900 dark:text-[#D1D2D3] truncate group-hover:text-blue-600 transition-colors",
        itemMeta: "flex items-center gap-2 mt-0.5",
        badge: "text-[10px] font-semibold px-2 py-0.5 rounded-full",
        chamadoNum: "text-[11px] text-gray-400 dark:text-[#ABABAD] font-mono",
        chevron: "text-gray-300 dark:text-[#565856] group-hover:text-blue-500 transition-colors",
        statusColors: {
            'pendente': "bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-400",
            'aberto': "bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-400",
            'concluido': "bg-green-50 text-green-700 dark:bg-green-500/10 dark:text-green-400",
            'recusado': "bg-red-50 text-red-700 dark:bg-red-500/10 dark:text-red-400",
            'cancelado': "bg-gray-50 text-gray-700 dark:bg-gray-500/10 dark:text-gray-400",
        },
        statusLabels: {
            'pendente': 'Pendente',
            'aberto': 'Aberto',
            'concluido': 'Concluído',
            'recusado': 'Recusado',
            'cancelado': 'Cancelado',
        },
        statBg: {
            amber: "bg-amber-50/80 dark:bg-amber-500/5",
            blue: "bg-blue-50/80 dark:bg-blue-500/5",
            green: "bg-green-50/80 dark:bg-green-500/5",
            red: "bg-red-50/80 dark:bg-red-500/5",
        },
        statText: {
            amber: "text-amber-700 dark:text-amber-400",
            blue: "text-blue-700 dark:text-blue-400",
            green: "text-green-700 dark:text-green-400",
            red: "text-red-600 dark:text-red-400",
        },
        empty: "flex flex-col items-center justify-center py-10 px-5 flex-1",
        emptyIcon: "w-11 h-11 rounded-2xl flex items-center justify-center bg-gray-100 dark:bg-[#383838] mb-2.5",
        emptyText: "text-sm font-medium text-gray-500 dark:text-[#ABABAD]",
        emptySubtext: "text-xs text-gray-400 dark:text-[#565856] mt-0.5",
        skeleton: "animate-pulse flex items-center gap-3 px-5 py-3",
        skeletonBar: "h-3 bg-gray-100 dark:bg-[#383838] rounded-full",
    },
    help: {
        title: "text-lg font-bold text-gray-900 dark:text-[#D1D2D3] mb-4",
        supportCard: "bg-white dark:bg-[#222529] rounded-xl border border-gray-200 dark:border-[#383838] p-4 flex items-center gap-4 mb-4",
        supportIconBox: "w-11 h-11 rounded-xl bg-green-500 flex items-center justify-center flex-shrink-0",
        supportContent: "flex-1 min-w-0",
        supportTitle: "text-sm font-bold text-gray-900 dark:text-[#D1D2D3]",
        supportPhone: "text-xs text-gray-500 dark:text-[#ABABAD] mt-0.5 font-medium",
        supportButton: "flex items-center gap-2 px-4 py-2.5 bg-green-500 hover:bg-green-600 text-white text-sm font-medium rounded-xl transition-colors flex-shrink-0",
        resourcesGrid: "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3",
        resourceCard: "group bg-white dark:bg-[#222529] rounded-xl border border-gray-200 dark:border-[#383838] p-4 flex flex-col items-center gap-2.5 text-center hover:shadow-md hover:border-gray-300 dark:hover:border-[#565856] transition-all duration-300 cursor-pointer",
        resourceIconBox: "w-12 h-12 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform",
        resourceLabel: "text-sm font-bold text-gray-900 dark:text-[#D1D2D3]",
        resourceDescription: "text-[11px] text-gray-500 dark:text-[#ABABAD] leading-relaxed",
    },
    meuPainel: {
        header: "flex items-center justify-between mb-5",
        iconBox: "w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50 dark:bg-[#7C3AED]/10",
        title: "text-lg font-bold text-gray-900 dark:text-[#D1D2D3]",
        subtitle: "text-xs text-gray-500 dark:text-[#ABABAD]",
        gridPrincipal: "grid grid-cols-2 md:grid-cols-4 gap-3 mb-3",
        gridSecundario: "grid grid-cols-3 gap-3 mb-6",
        card: "bg-white dark:bg-[#222529] rounded-xl border border-gray-200 dark:border-[#383838] p-4 flex items-center gap-3 hover:shadow-md hover:border-gray-300 dark:hover:border-[#565856] transition-all duration-300",
        cardIconBox: "w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0",
        cardInfo: "flex flex-col min-w-0",
        cardValue: "text-xl font-bold text-gray-900 dark:text-[#D1D2D3] leading-tight",
        cardLabel: "text-xs text-gray-500 dark:text-[#ABABAD] mt-0.5",
        chartWrapper: "mt-1",
        colors: {
            blue: { bg: "bg-blue-50 dark:bg-blue-500/10", text: "text-blue-600 dark:text-blue-400" },
            violet: { bg: "bg-violet-50 dark:bg-violet-500/10", text: "text-violet-600 dark:text-violet-400" },
            red: { bg: "bg-red-50 dark:bg-red-500/10", text: "text-red-600 dark:text-red-400" },
            green: { bg: "bg-green-50 dark:bg-green-500/10", text: "text-green-600 dark:text-green-400" },
            amber: { bg: "bg-amber-50 dark:bg-amber-500/10", text: "text-amber-600 dark:text-amber-400" },
            indigo: { bg: "bg-indigo-50 dark:bg-indigo-500/10", text: "text-indigo-600 dark:text-indigo-400" },
        },
    },
};
